export default filtersObject => {
  let filterList = [];
  if (filtersObject && filtersObject.length > 0) {
      filtersObject.forEach(filter => {
        
        let key = filter?.name;
        let value = filter?.values;

        if (Array.isArray(value) || typeof value === 'object') {

          // is facet type range
          let isRange = (value.min || value.min === 0) && (value.max || value.max === 0);

          if (isRange) {
            let maxValue = value.max;
            let minValue = value.min;

            let filter = {
              name: key,
              type: 'range',
              minValue: minValue,
              maxValue: maxValue,
              range: [minValue, maxValue]
            };

            filterList.push(filter);
          } else {
            let filters = [];
            value.forEach(elem => {
              let filter = {
                name: elem?.name,
                value: elem?.value,
                count: elem?.count,
                selected: false
              };

              filters.push(filter);
            });

            let filter = {
              name: key,
              filters: filters.sort(compare)
            };

            filterList.push(filter);
          }
        }
      });
  }
  return filterList;
};

const compare = ( a, b ) => {
  // Sort by number
  let a_value = typeof parseFloat(a.value) === 'number' ? parseFloat(a.value) : a.value;
  let b_value = typeof parseFloat(b.value) === 'number' ? parseFloat(b.value) : b.value;
  if ( a_value < b_value ){
    return -1;
  }
  if ( a_value > b_value ){
    return 1;
  }
  // Otherwise sort alphabetical
  return a.value?.toString().localeCompare(b.value);
}